<script>
  import { onMount } from 'svelte';
  import { elasticOut, backIn } from 'eases-jsnext';
  import { fade, fly } from 'svelte/transition';
  import { country } from './store.js';
  import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

  export let count;
  export let bc;
  export let sc;
  export let cost;
  export let blimg;
  export let spimg;

  let show = false, openCart = false, cname;

  function toggleCart() {
    openCart = !openCart;
  }

	onMount(() => {
		show = true;
  });
  $: cname = $country == 'ca' ? 'Canada' : 'United States';
</script>

<header>
  {#if show}
    <a class="logo" href="https://www.healthybud.co" in:fly="{{ x: -20, duration: 1000, delay: 0, easing: elasticOut }}">
      <svg viewBox="0 0 420.49 76.33"><title>The Healthybud logo Click here to go back to the main website</title><path fill="#58cfeb" d="M154.65 53.4a3.33 3.33 0 0 1-3.33 3.33c-7 0-11.11-4.3-11.11-10.5V3.33A3.33 3.33 0 0 1 143.54 0h.33a3.34 3.34 0 0 1 3.34 3.33v42.85c0 2.11 1.53 3.5 4.11 3.5a3.34 3.34 0 0 1 3.33 3.34zM379.38 36.83c0 11.11 8.42 20.11 18.81 20.11a18.43 18.43 0 0 0 15.3-8.49v5.11a3.5 3.5 0 0 0 3.5 3.5 3.49 3.49 0 0 0 3.5-3.5V3.5a3.49 3.49 0 0 0-3.5-3.5 3.5 3.5 0 0 0-3.5 3.5v21.72a18.41 18.41 0 0 0-15.34-8.49c-10.35 0-18.77 9-18.77 20.1zm6.62.07c0-7.7 5.64-13.07 12.58-13.07s12.57 5.37 12.57 13.07-5.64 14-12.58 14S386 44.6 386 36.9zM309.86 16.77a18.42 18.42 0 0 0-15.3 8.49V3.5a3.5 3.5 0 0 0-3.5-3.5 3.5 3.5 0 0 0-3.5 3.5v50a3.5 3.5 0 0 0 3.5 3.5 3.5 3.5 0 0 0 3.5-3.5v-5a18.42 18.42 0 0 0 15.3 8.49c10.39 0 18.81-9 18.81-20.1s-8.42-20.12-18.81-20.12zm-.39 34.14c-6.94 0-12.58-6.27-12.58-14s5.64-13.07 12.58-13.07 12.58 5.37 12.58 13.07-5.64 14-12.58 14zM63.15 49.98a13.47 13.47 0 0 1-13.26-11.15h26.45a3.73 3.73 0 0 0 3.71-4.05c-1-11.77-6.34-16.76-14.5-17.81-9.89-1.28-19.4 4.5-22.09 14.11a20.17 20.17 0 0 0 19.31 25.9 20 20 0 0 0 15.08-6.88 3.28 3.28 0 0 0-.41-4.64 3.31 3.31 0 0 0-4.57.29 13.31 13.31 0 0 1-9.72 4.23zm-.79-27c5.73 0 9.59 2.31 11.07 8.82h-23a12.37 12.37 0 0 1 11.91-8.78zM185.62 50.06a2.68 2.68 0 0 0-3.1-.35 8.52 8.52 0 0 1-4.05 1.16c-3.41 0-6.19-2.26-6.33-4.84V23.52h7.91a2.72 2.72 0 0 0 2.72-2.72v-.06a2.72 2.72 0 0 0-2.72-2.72h-7.9V2.72A2.72 2.72 0 0 0 169.43 0h-.83a2.72 2.72 0 0 0-2.72 2.68c0 2.84-.09 9.25-.14 15.34h-4.24a2.72 2.72 0 0 0-2.72 2.72v.06a2.72 2.72 0 0 0 2.72 2.72h4.21c0 10.84 0 21.18.35 23.68.74 5.37 5.4 9.55 12.08 9.55a12.07 12.07 0 0 0 7.34-2.48 2.71 2.71 0 0 0 .15-4.21zM215.44 15.66a15.33 15.33 0 0 0-13 7.23V3.5a3.5 3.5 0 0 0-3.5-3.5 3.5 3.5 0 0 0-3.5 3.5v50.07a3.5 3.5 0 0 0 3.5 3.5h.09a3.51 3.51 0 0 0 3.5-3.4l.62-20.11c.6-6.19 6-11.31 10.65-11.31s10 2.82 10 8.76v22.56a3.5 3.5 0 0 0 3.5 3.5 3.5 3.5 0 0 0 3.5-3.5V31.01a15.4 15.4 0 0 0-15.36-15.35zM19.96 15.65a15.33 15.33 0 0 0-13 7.23V3.5A3.5 3.5 0 0 0 3.46 0a3.5 3.5 0 0 0-3.5 3.5v50.06a3.5 3.5 0 0 0 3.5 3.5h.09a3.5 3.5 0 0 0 3.5-3.4l.53-20.12c.6-6.19 6-11.3 10.65-11.3s10 2.82 10 8.76v22.56a3.5 3.5 0 0 0 3.5 3.5 3.5 3.5 0 0 0 3.5-3.5V31a15.4 15.4 0 0 0-15.27-15.35zM363.51 20.3v22.1c-1.54 4.54-6.16 8-10.15 8-4.61 0-10-2.82-10-8.76V20.3a3.47 3.47 0 0 0-3.47-3.47h-.05a3.47 3.47 0 0 0-3.47 3.47v21.33a15.39 15.39 0 0 0 15.35 15.35 15.27 15.27 0 0 0 11.84-5.73v2.28a3.47 3.47 0 0 0 3.47 3.53 3.46 3.46 0 0 0 3.47-3.46l.09-33.29a3.47 3.47 0 0 0-3.47-3.48 3.47 3.47 0 0 0-3.61 3.47zM276.48 20.26a3.46 3.46 0 0 0-3.46-3.46h-.08a3.46 3.46 0 0 0-3.46 3.46l-.64 18.82c-.1 5.72-6.06 11.32-10.63 11.32s-10-2.81-10-8.75V20.29a3.46 3.46 0 0 0-3.46-3.46h-.08a3.46 3.46 0 0 0-3.52 3.46v21.32a15.39 15.39 0 0 0 15.35 15.34 15.32 15.32 0 0 0 13-7.27v8.19c0 6.51-4.29 11.47-12.07 11.47-6 0-9.94-3.21-11.51-7.66a3.46 3.46 0 1 0-6.53 2.29c2.61 7.18 9 12.36 18 12.36 11.66 0 19.06-8.07 19.06-18.46zM130.45 51.46c-.58-1-1.56-1.46-1.79-3.85V20.33a3.5 3.5 0 0 0-7 0v4.93a18.41 18.41 0 0 0-15.3-8.49c-10.39 0-18.81 9-18.81 20.11s8.42 20.1 18.81 20.1a18.41 18.41 0 0 0 15.3-8.49v.07a.5.5 0 0 0 0-.12 12.49 12.49 0 0 0 2.89 6.67c1.43 1.67 3.44 2.27 5.07 1l.26-.22a3.38 3.38 0 0 0 .57-4.43zm-23.7-.55c-6.93 0-12.58-6.27-12.58-14s5.65-13.07 12.58-13.07 12.58 5.37 12.58 13.07-5.64 14-12.58 14z"/></svg>
    </a>
    {#if $country != null}
      <button 
        class="country-btn"
        on:click={() => dispatch("switchCountry")}
        in:fly="{{ x: 20, duration: 1000, delay: 0, easing: elasticOut }}"
        >
        <img src="{$country}.png" class="country-image" alt="{cname} is your selected country, click to change"/>
      </button>
    {/if}
    <button
      class="cart-btn"
      aria-label="This button opens the cart, no need to click you have {count? count : 'no'} item{count == 1? '' : 's'} in your cart. {count? 'Breakdown:' : ''} {bc? bc + ' Beef Lung Treat bag' : ''}{count && bc > 0 && bc != 1? 's' : ''} {bc && sc? 'and' : ''}  {sc? sc + ' Sweet Potato Treat bag' : ''}{count && sc > 0 && sc != 1? 's' : ''}"
      on:click="{toggleCart}"
      in:fly="{{ x: 20, duration: 1050, delay: 50, easing: elasticOut }}"
      >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>
      {#if count}
        <span in:fly="{{ y: 10, duration: 200, delay: 75, easing: elasticOut }}" out:fly="{{ y: 10, duration: 300, delay: 0, easing: backIn }}">{count}</span>
      {/if}
    </button>

    {#if openCart}
    <div class="cart-overlay" in:fly="{{ y: 50, duration: 200, delay: 75 }}" out:fly="{{ y: 50, duration: 300, delay: 0, easing: backIn }}">
      <div class="cart-main">
        {#if count}
          {#if bc}
            <div class="qty-btn">
              <img src={blimg} alt="Beef Lung Bag" class="cart-image" />
              <span>{bc}</span>
            </div>              
          {/if}
          {#if sc}
            <div class="qty-btn">
              <img src={spimg} alt="Sweet Potato Bag" class="cart-image" />
              <span>{sc}</span>
            </div>
          {/if}
        {:else}
          <p>Your cart is empty</p>
        {/if}
      </div>
      <div class="cart-header">
        <p>Subtotal</p>
      </div>
      <div class="cart-total">
        <p><span>$</span>{cost.toFixed(2)}</p>
      </div>

    </div>
      <div in:fade out:fade class="overlay" on:click="{toggleCart}">
      </div>
    {/if}
  {/if}
</header>

<style>
header {
  display: grid;
  height: 80px;
  padding: .75rem;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  max-width: 580px;
  grid-template-columns: 40px 40px 1fr 40px 40px;
  position: relative;
  padding: .25rem .5rem;
  grid-gap: 10px;
}
.logo {
  grid-column: 1 / 4;
  text-align: left;
}
.logo svg {
  height: 50px;
  justify-self: left;
  max-width: 90%;
}
.country-btn {
  grid-column: 4 / 5;
  padding: 4px;
  height: 40px;
  width: 40px;
}
.country-image {
  height: auto;
  width: 100%;
}
.cart-btn {
  grid-column: 5 / 6;
  height: 40px;
  width: 40px;
}
button {
  justify-self: end;
  cursor: pointer;
  color: #333;
  background: #fff;
  border: none;
  border-radius: 50px;
  z-index: 10;
  position: relative;
}
button:hover {
  background: #efefef;
}
button span {
  position: absolute;
  background: #FFB961;
  top: -5px;
  right: -5px;
  height: 20px;
  width: 20px;
  font-weight: bold;
  border-radius: 50px;
  font-size: .8rem;
  padding: 1px;
  line-height: 20px;
  text-align: center;
}
.cart-overlay {
  background: #fff;
  border-radius: 0.75rem;
  height: 200px;
  width: 300px;
  max-width: 100%;
  z-index: 10;
  position: absolute;
  top: 82px;
  right: 0;
  overflow: hidden;
  box-shadow: 0 3px 6px rgba(27,37,38,.16);
  display: grid;
  grid-template-columns: 1fr 80px;
  grid-template-rows: 1fr 60px;
  grid-template-areas:
  "m m"
  "h t"
}
.qty-btn {
  position: relative;
  border-radius: .5rem;
}
.qty-btn span {
  position: absolute;
  background: #FFB961;
  top: -5px;
  right: -5px;
  height: 20px;
  width: 20px;
  font-weight: bold;
  border-radius: 50px;
  font-size: .8rem;
  padding: 1px;
  line-height: 20px;
  text-align: center;
  border: 2px solid #efefef;
}
.cart-main {
  grid-area: m;
  background: #efefef;
  display: grid;
  align-content: center;
  justify-content: center;
  grid-template-columns: repeat(3, 70px);
  align-items: center;
  grid-template-rows: 104px;
  grid-gap: 20px;
  padding: 0px;
}
.cart-main p {
  grid-area: 1 / 1 / -1 / -1;
  justify-self: center;
  font-weight: bold;
}
.cart-image {
  width: 100%;
  height: auto
}
.cart-header {
  grid-area: h;
  font-weight: bold;
  color: #494025;
  font-size: 18px;
  position: relative;
  background: #fec988;
  display: grid;
  align-content: center;
  justify-content: center;
}
.cart-total {
  grid-area: t;
  background: #FFB961;
  display: grid;
  align-content: center;
  justify-content: center;
  font-weight: bold;
}
.overlay {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000;
  opacity: .2;
  z-index: 9;
}

@media (min-width: 768px) {
  .logo {
    grid-column: 3 / 4;
    text-align: center;
  }
}
</style>